<div class="second-insured">
  <div class="column">
    <div class="second-insured-name" appConfigSettingsInput>
      <div>
        <app-initials-component
          placeholder="Insured.Initials"
          [control]="insuredFormGroup.get('initials')"
          [form]="insuredFormGroup"
        ></app-initials-component>
      </div>
      <div>
        <app-text-input
          class="full-width"
          placeholder="Insured.MiddleName"
          [control]="insuredFormGroup.get('middleName')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
        ></app-text-input>
      </div>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Surname"
        [control]="insuredFormGroup.get('surname')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
        capitalize="true"
      ></app-text-input>
    </div>
    <div>
      <app-toggle-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.Gender"
        [form]="insuredFormGroup"
        [optionsList]="genderList"
        [control]="insuredFormGroup.get('gender')"
        [formSubmitted]="true"
      ></app-toggle-input>
    </div>
    <div class="isEqualAddress">
      <app-toggle-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.AddressSameAsFirstInsured"
        [form]="insuredFormGroup"
        [optionsList]="yesNoList"
        [control]="insuredFormGroup.get('addressSameAsFirstInsured')"
        [formSubmitted]="true"
      ></app-toggle-input>
    </div>

    <div *ngIf="notSameAddress">
      <div class="second-insured-address">
        <div
          class="second-insured-address-zipCode"
          appConfigSettingsInput
        >
          <app-text-input
            class="full-width"
            appConfigSettingsInput
            placeholder="Insured.ZipCode"
            [control]="insuredFormGroup.get('zipCode')"
            [form]="insuredFormGroup"
            showPlaceholder="false"
            inputMask="0000 SS"
            [dropSpecialCharacters]="false"
            uppercase="true"
          ></app-text-input>
        </div>
        <div
          class="second-insured-address-houseNumber"
          appConfigSettingsInput
        >
          <app-text-input
            class="full-width"
            placeholder="Insured.HouseNumber"
            [control]="insuredFormGroup.get('houseNumber')"
            [form]="insuredFormGroup"
            showPlaceholder="false"
            type="number"
            [isLoaderShown]="isZipCodeLoaderShown"
          ></app-text-input>
        </div>
        <div
          class="second-insured-address-houseNumberSuffix"
          appConfigSettingsInput
        >
          <app-text-input
            class="full-width"
            placeholder="Insured.HouseNumberSuffix"
            [control]="insuredFormGroup.get('houseNumberSuffix')"
            [form]="insuredFormGroup"
            showPlaceholder="false"
          ></app-text-input>
        </div>
        <div
          class="second-insured-address-message"
          *ngIf="isEmptyZipCodeServiceResultMessageShown"
        >
          {{ "Common.PostCodeAddressNotFound" | translate }}
        </div>
      </div>
      <div>
        <app-text-input
          class="full-width"
          appConfigSettingsInput
          placeholder="Insured.Street"
          [control]="insuredFormGroup.get('street')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
        ></app-text-input>
      </div>
      <div>
        <app-text-input
          class="full-width"
          appConfigSettingsInput
          placeholder="Insured.City"
          [control]="insuredFormGroup.get('city')"
          [form]="insuredFormGroup"
          showPlaceholder="false"
        ></app-text-input>
      </div>
    </div>
  </div>

  <div class="column">
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.MobilePhoneNo"
        [control]="insuredFormGroup.get('mobilePhoneNo')"
        [form]="insuredFormGroup"
        [pattern]="phonePattern"
        [inputMask]="phoneMask"
        showPlaceholder="false"
        prefix="+31 (0)"
        dropSpecialCharacters="true"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.EmailAddress"
        [control]="insuredFormGroup.get('emailAddress')"
        [form]="insuredFormGroup"
        showPlaceholder="false"
      ></app-text-input>
    </div>
    <div>
      <app-text-input
        class="full-width"
        appConfigSettingsInput
        placeholder="Insured.SecondEmailAddress"
        [control]="insuredFormGroup.get('confirmedEmailAddress')"
        [form]="insuredFormGroup"
        additionalInfoInsurer="AdditionalInformation.ConfirmEmail"
        showPlaceholder="false"
      ></app-text-input>
    </div>
  </div>
</div>
